import type { Project } from '../types';

// Projects use a loose free-text target_timeframe ("Now", "Oct 1, 2026",
// "June 2028") instead of a hard due date, since the work is open-ended.
// This gives every project a best-effort sort key so lists can still show
// soonest-first: "now"/"asap" sort before any dated entry, parseable dates
// sort by their real value, and anything else (or blank) sorts last.
export function projectSortKey(project: Project): number {
  const tf = project.target_timeframe?.trim().toLowerCase();
  if (!tf) return Infinity;
  if (tf === 'now' || tf === 'asap' || tf === 'today') return -Infinity;
  const parsed = Date.parse(project.target_timeframe!);
  return Number.isNaN(parsed) ? Infinity : parsed;
}

export function sortProjectsByTimeframe(projects: Project[]): Project[] {
  return [...projects].sort((a, b) => {
    const diff = projectSortKey(a) - projectSortKey(b);
    if (diff !== 0) return diff;
    // Stable-ish fallback for equal/unknown timeframes: newest-created first.
    return a.created_at < b.created_at ? 1 : -1;
  });
}
